import { graphql, Link } from 'gatsby';
import { FluidObject } from 'gatsby-image';
import Img from 'gatsby-image';
import * as _ from 'lodash';
import { css } from '@emotion/react';
import '../../components/website/CopyRight/CopyRight.css';
import { colors } from '../../styles/colors';
import styled from '@emotion/styled';
import { lighten, setLightness } from 'polished';
import React from 'react';
import { Helmet } from 'react-helmet';
import config from '../../website-config';
import PostContent from '../../components/blog/PostContent';
import EmailCollectorTemplates from "../../components/website/Newsletter/EmailCollectorTemplates";
import BlogLayout from '../../layouts/BlogLayout';
export interface Author {
  id: string;
  bio: string;
  avatar: {
    children: Array<{
      fluid: FluidObject;
    }>;
  };
}

interface PageTemplateProps {
  location: Location;
  data: {
    logo: {
      childImageSharp: {
        fixed: any;
      };
    };
    mdx: {
      body: string;
      // htmlAst: any;
      excerpt: string;
      frontmatter: {
        title: string;
        downloadLink: string;
        date: string;
        price: string;
        datemodified: string;
        userDate: string;
        displayImage: {
          childImageSharp: {
            fluid: any;
          };
        };
        image1: {
          childImageSharp: {
            fluid: any;
          };
        };
        image2: {
          childImageSharp: {
            fluid: any;
          };
        };
        image3: {
          childImageSharp: {
            fluid: any;
          };
        };
        image4: {
          childImageSharp: {
            fluid: any;
          };
        };
        excerpt: string;
        tags: string[];
        author: Author[];
      };
      fields: {
        readingTime: {
          text: string;
        };
      };
    };
    relatedPosts: {
      totalCount: number;
      edges: Array<{
        node: {
          timeToRead: number;
          frontmatter: {
            title: string;
            date: string;
            price: string;
            datemodified: string;
          };
          fields: {
            slug: string;
          };
        };
      }>;
    };
  };
  pageContext: {
    prev: PageContext;
    next: PageContext;
  };
}

export interface PageContext {
  excerpt: string;
  fields: {
    slug: string;
    readingTime: {
      text: string;
    };
  };
  frontmatter: {
    displayImage: {
      childImageSharp: {
        fluid: FluidObject;
      };
    };
    image1: {
      childImageSharp: {
        fluid: FluidObject;
      };
    };
    image2: {
      childImageSharp: {
        fluid: FluidObject;
      };
    };
    image3: {
      childImageSharp: {
        fluid: FluidObject;
      };
    };
    image4: {
      childImageSharp: {
        fluid: FluidObject;
      };
    };
    excerpt: string;
    title: string;
    downloadLink: string;
    price: string;
    date: string;
    datemodified: string;
    draft?: boolean;
    tags: string[];
    author: Author[];
  };
}

const PageTemplate = ({ data }: PageTemplateProps) => {
  const post = data.mdx;
  let width = '';
  let height = '';
  if (post.frontmatter.displayImage?.childImageSharp) {
    width = post.frontmatter.displayImage.childImageSharp.fluid.sizes.split(', ')[1].split('px')[0];
    height = String(
      Number(width) / post.frontmatter.displayImage.childImageSharp.fluid.aspectRatio,
    );
  }
  const url = typeof window !== 'undefined' ? window.location.href : '';
  return (
    <BlogLayout>
      <Helmet>
      <title>{`${post.frontmatter.title}`}</title>
          <meta name="description" content={`${post.frontmatter.excerpt}`} />
          <meta name="keywords" content={`${config.keyword}`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={`${post.frontmatter.title}`} />
          <meta property="og:description" content={`${post.frontmatter.excerpt}`} />
          <meta property="og:url" content={`${config.siteUrl}`} />
          <meta property="og:image:width" />
          <meta property="og:image:height" />
        <script type="application/ld+json">
          {`{
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": "${post.frontmatter.title}",
      "image": [
        "${post.frontmatter.displayImage.childImageSharp.fluid.src}"
       ],
      "description": "${post.frontmatter.excerpt}",
      "sku": "0446310786",
      "mpn": "925872",
      "brand": {
        "@type": "Brand",
        "name": "${config.title}"
      },
      "review": {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "${post.frontmatter.author[0].id}"
        }
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.4",
        "reviewCount": "89"
      },
      "offers": {
        "@type": "Offer",
        "url": "${config.siteUrl}",
        "priceCurrency": "USD",
        "price": "${post.frontmatter.price}",
        "priceValidUntil": "2020-11-20",
        "itemCondition": "https://schema.org/UsedCondition",
        "availability": "https://schema.org/InStock"
      }
      ,
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://bizdamn.tech"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Graphic Templates",
        "item": "https://bizdamn.tech/graphic-templates"
      }]
    },
    {
      "@context": "https://schema.org/",
      "@type": "WebPage",
      "name": ${config.title},
      "speakable":
      {
       "@type": "SpeakableSpecification",
       "xPath": [
         "/html/head/title",
         "/html/head/meta[@name='description']/@content"
         ]
       },
      "url": ${url}
    }`}
        </script>
      </Helmet>
      {/* Breadcrumbs */}
      <section className="breadcrumbs fixed-top">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <ol>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/graphic-templates">Canva Templates</Link>
              </li>
              {/* <li>{post.frontmatter.tags[0]}</li> */}
            </ol>
          </div>
        </div>
      </section>

      <div style={{ marginTop: '7rem' }} className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="">
              <div className="iq-card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">
                  {post.frontmatter.tags && post.frontmatter.tags.length > 0 && (
                    <Link to={`/graphic-templates/${_.kebabCase(post.frontmatter.tags[0])}/`}>
                      {post.frontmatter.tags[0]}
                    </Link>
                  )}
                </h4>
              </div>

              <div className="iq-card-body pb-0">
                <div className="description-contens align-items-top row">
                  <div className="col-md-6">
                    <div
                      id="carouselExampleIndicators"
                      className="carousel slide"
                      data-ride="carousel"
                    >
                      <ol className="carousel-indicators">
                        <li
                          data-target="#carouselExampleIndicators"
                          data-slide-to="0"
                          className="active"
                        ></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                      </ol>
                      <div className="carousel-inner">
                        <div className="img-wrapper carousel-item active">
                          {post.frontmatter?.image1?.childImageSharp?.fluid && (
                            <Img
                              className="zoom-on-hover d-block w-100"
                              alt={`${post.frontmatter.title} cover image`}
                              style={{ height: '100%' }}
                              fluid={post.frontmatter.image1.childImageSharp.fluid}
                            />
                          )}
                        </div>
                        <div className="carousel-item">
                          {post.frontmatter?.image2?.childImageSharp?.fluid && (
                            <Img
                              className="d-block w-100"
                              alt={`${post.frontmatter.title} cover image`}
                              style={{ height: '100%' }}
                              fluid={post.frontmatter.image1.childImageSharp.fluid}
                            />
                          )}
                        </div>
                        <div className="carousel-item">
                          {post.frontmatter?.image3?.childImageSharp?.fluid && (
                            <Img
                              className="d-block w-100"
                              alt={`${post.frontmatter.title} cover image`}
                              style={{ height: '100%' }}
                              fluid={post.frontmatter.image1.childImageSharp.fluid}
                            />
                          )}
                        </div>
                      </div>
                      <a
                        className="carousel-control-prev"
                        href="#carouselExampleIndicators"
                        role="button"
                        data-slide="prev"
                      >
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                      </a>
                      <a
                        className="carousel-control-next"
                        href="#carouselExampleIndicators"
                        role="button"
                        data-slide="next"
                      >
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                      </a>
                    </div>
                  </div>

                  <div className="col-md-6 d-flex align-items-center">
                    <div className="iq-card-transparent iq-card-block iq-card-stretch iq-card-height">
                      <div className="iq-card-body p-0 ">
                        <PostFullTitle style={{ textAlign: 'center' }} className="post-full-title">
                          {post.frontmatter.title}
                        </PostFullTitle>

                        <PostFullCustomExcerpt
                          style={{ textAlign: 'center' }}
                          className="text-dark mb-4 pb-4  d-block abnfpost-full-custom-excerpt"
                        >
                          {post.frontmatter.excerpt}
                        </PostFullCustomExcerpt>
                        <div className="iq-border-bottom mb-4 pb-4 d-block price d-flex align-items-center font-weight-500 mb-2">
                          {/* <span className="font-size-20 pr-2 old-price">$99</span> */}
                          <span className="font-size-24 text-dark">Free</span>
                        </div>
                        <div style={{ height: '2rem' }} className="social-menu-div">
                          <ul>
                            <li data-sal="slide-up">
                              <a
                                href={`http://www.facebook.com/sharer.php?u=${post.frontmatter.downloadLink}&p[title]=${post.frontmatter.title}`}
                              >
                                <i className="fab fa-facebook-f"></i>
                              </a>
                            </li>
                            <li data-sal="slide-up">
                              <a
                                href={`http://pinterest.com/pin/create/button/?url=${post.frontmatter.downloadLink}=&description=${post.frontmatter.title}`}
                              >
                                <i className="fab fa-pinterest-p"></i>
                              </a>
                            </li>
                          </ul>
                        </div>

                        <div className="my-4 d-flex align-items-center justify-content-center">
                          {/* <a href={post.frontmatter.downloadLink} className="premium-btn-black">
                            Get Your Template
                          </a> */}
                            <EmailCollectorTemplates link={post.frontmatter.downloadLink}/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <PostContent mainContent={post.body} />
        </div>
      </div>
    </BlogLayout>
  );
};

export const PostFull = css`
  position: relative;
  z-index: 50;
`;

export const NoImage = css`
  .post-full-content {
    padding-top: 0;
  }

  .post-full-content:before,
  .post-full-content:after {
    display: none;
  }
`;

export const PostFullHeader = styled.header`
  position: relative;
  margin: 10px;
  padding: 0 50px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;

  @media (max-width: 1170px) {
    padding: 60px 11vw 50px;
  }

  @media (max-width: 800px) {
    padding-right: 5vw;
    padding-left: 5vw;
  }

  @media (max-width: 500px) {
    padding: 20px 0 35px;
  }
`;

const PostFullCustomExcerpt = styled.p`
  margin: 20px 0 0;
  color: var(--midgrey);
  font-family: Open Sans;
  font-size: 2.3rem;
  line-height: 1.4em;
  font-weight: 300;

  @media (max-width: 500px) {
    font-size: 1.9rem;
    line-height: 1.5em;
  }

  @media (prefers-color-scheme: dark) {
    /* color: color(var(--midgrey) l(+10%)); */
    color: ${lighten('0.1', colors.midgrey)};
  }
`;

export const PostFullTitle = styled.h1`
  margin: 0;
  color: ${setLightness('0.05', colors.darkgrey)};
  @media (max-width: 500px) {
    margin-top: 0.2em;
    font-size: 3.3rem;
  }

  @media (prefers-color-scheme: dark) {
    color: rgba(255, 255, 255, 0.9);
  }
`;

export const query = graphql`
  query ($slug: String, $primaryTag: String) {
    logo: file(relativePath: { eq: "avatars/Logo.png" }) {
      childImageSharp {
        fixed {
          ...GatsbyImageSharpFixed
        }
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      body
      excerpt
      fields {
        readingTime {
          text
        }
      }
      frontmatter {
        title
        userDate: date(formatString: "D MMMM YYYY")
        date
        datemodified
        downloadLink
        tags
        excerpt
        displayImage {
          childImageSharp {
            fluid(maxWidth: 3720) {
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
        image1 {
          childImageSharp {
            fluid(maxWidth: 3720) {
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
        image2 {
          childImageSharp {
            fluid(maxWidth: 3720) {
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
        image3 {
          childImageSharp {
            fluid(maxWidth: 3720) {
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
        image4 {
          childImageSharp {
            fluid(maxWidth: 3720) {
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
        author {
          id
          bio
          avatar {
            children {
              ... on ImageSharp {
                fluid(quality: 100, srcSetBreakpoints: [40, 80, 120]) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
    relatedPosts: allMdx(
      filter: { frontmatter: { tags: { in: [$primaryTag] }, draft: { ne: true } } }
      limit: 5
      sort: { fields: [frontmatter___datemodified], order: DESC }
    ) {
      totalCount
      edges {
        node {
          id
          excerpt
          frontmatter {
            title
            date
            datemodified
          }
          fields {
            readingTime {
              text
            }
            slug
          }
        }
      }
    }
  }
`;

export default PageTemplate;
